import API from "../../Config/API";

export const watchModule = (viewType) => {
  return async (dispatch) => {
    try {
      const data = await API.post("/viewed", viewType);
    } catch (error) {}
  };
};
